import React from 'react'
import styled from 'styled-components'
import {
  CardDashboardProps,
  HeaderStyledCardProps,
} from './card-dashboard.types'
import { Heading } from '../heading'

export const StyledCard = styled.div`
  ${({ theme }) =>
    `
      display: block;
      border-radius: ${theme.borderRadii.large};
      background-color: ${theme.colors.white};
      font-size: ${theme.fontSizes.bodySmall};
      font-weight: ${theme.fontWeights.medium};
      padding: ${theme.sizes['m']};
    `}
`

export const HeaderStyledCard = styled.div<HeaderStyledCardProps>`
  ${({ theme, $hasTitle }) => `
    align-items: start;
    display: flex;
    justify-content: ${$hasTitle ? 'space-between' : 'flex-end'};
    margin-bottom: ${theme.sizes['s']};
  `}
`

export const CardDashboard = ({
  action,
  title,
  headingLevel = 'h2',
  children,
  ...props
}: CardDashboardProps) => (
  <StyledCard {...props}>
    {(title || action) && (
      <HeaderStyledCard $hasTitle={!!title}>
        {title && (
          <Heading level={headingLevel} data-testid="card-dashboard-heading">
            {title}
          </Heading>
        )}
        {action}
      </HeaderStyledCard>
    )}

    {children}
  </StyledCard>
)
